export const checkout = {
    upload: {
        hero: {
            title: 'Your industrial 3D printing service',
            subtitle: 'Order your 3D printed part in just a few steps.',
        },
        choose3DFile: 'Choose 3D-File',
        startDemo: 'Start demo',
        dontHaveAFileYet: 'No 3D file within reach?',
        dragAndDrop3DFile:
            'Upload your 3D file using the drag and drop function',
        or: 'or',
        defaultHeader: 'Online Order Portal',
        defaultSubtitle: 'Upload your files here',
        chooseDifferent3DFile: 'Upload new object',
        addAnother3DFile: 'Upload another 3D file',
        uploadState: {
            convertingToSTL: 'Converting to stl',
            analyzing: 'Analyzing',
            convertingToTRF: 'Converting to rtf',
            analyzingDimensions: 'Analyzing Volume and Dimensions',
            fileIsUploading: 'Uploading',
            repairing: 'Repairing file',
        },
    },
    analysis: {
        printQualityInfo: {
            tooLargeHeader: 'The object is too large for all print modes',
            notPrintableHeader:
                'This object is not printable in the given configuration!',
            notPrintableBody:
                "Please inquire a non-bindung quote via this <a href='/kontakt#cart-steps' target='_blank'>contact form</a>.",
            mightCauseProblemsHeader: 'Printing results could be improved:',
            mightCauseProblemsBody:
                "Parts of the model may be too thin due to current scaling. Visit our <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>design guidelines</a> for further information.",
            filePrintableHeader: '3D printing is possible:',
            filePrintableBody:
                "No problems occurred during the automatic model check. Please check our <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>design guidelines</a> for further information.",
            tooLargeForSelectedPrintmodeHeader:
                'The object is too large for the chosen print mode',
            tooLargeForSelectedPrintmodeBody: 'Please contact us via email at <a href="mailto:info-as@murtfeldt.de">info-as@murtfeldt.de</a>.',
            printabilityIsBeingCalculated: 'Checking Printability',
        },
    },
    configure: {
        objectMeasurements: 'Your object has the following dimensions',
        '3dRender': '3D-View',
        wallThicknesses: 'Wall thickness',
        repairData: 'Repair Info',
        inputLabels: {
            objectName: 'Object name',
            givenUnitOfLength: 'Which length unit was used?',
            materialAndColor: 'Please select material and colors:',
            scale: 'Scale',
            unit: 'Unit',
            quantity: 'Quantity',
            finishOptions: 'Finish-Options',
            untreated: 'Untreated',
        },
        rotateObjectInstruction:
            'Rotate the object by dragging with your mouse.',
    },
    nextStep: 'Next',
    addToCart: 'Add to shopping cart',
    steps: {
        choose3DFile: 'Upload 3D File',
        choosePrintMode: 'Select print settings',
        checkout: 'Checkout',
    },
    cart: {
        label: 'Cart',
        cartIsEmpty: 'Your cart is empty.',
        actionLabels: {
            addToCart: 'Add to cart',
            generateQuote: 'Get a quote',
            completeOrder: 'Complete Order',
            editPaymentDetails: 'Edit payment details',
            chooseFinishes: 'Weiter',
            goBack: 'Go back',
            close: 'Close',
        },
        noTaxIncluded: 'no tax included',
        includingVAT: 'all prices include the value added tax (if applicable)',
        includingXPercentTaxes:
            'all prices including {taxRate} % VAT. (if applicable)',
        plusXPercentTaxes: 'plus. {taxRate} % VAT',
        isPiecePrice: 'p. piece',
        isFullPrice: 'Total',
        itemLabels: {
            name: 'Item',
            namePlural: 'Items',
            size: 'Size in ',
            printMode: 'Printmode / Colour',
            quantity: 'Amount',
            priceSingle: 'Piece',
            priceSum: 'Sum',
            delete: 'Delete',
            attachments: 'Attachments',
            uploadAttachment: 'Upload Attachment',
        },
    },
    orderStatusLabels: {
        QUOTE_GENERATED: 'Offer requested',
        ORDER_RECEIVED: 'Order received',
        READY_FOR_PROCESSING: 'Ready for processing',
        CUSTOMER_CONTACTED: 'Customer contacted',
        FILES_PRINTABLE: 'Files are printable',
        FILES_NOT_PRINTABLE: 'Files are not printable',
        SUPPLIER_REQUEST_SENT: 'Request sent to supplier',
        IN_PRODUCTION: 'Parts are in production',
        PARTS_DEFECTIVE: 'Parts are defective',
        PARTS_REVIEWED: 'Parts are error-free',
        ORDER_CANCELLED: 'Order cancelled',
        ORDER_COMPLETED: 'Order completed',
        UNKNOWN: 'Open',
    },
    paymentMethodLabels: {
        prepaid: 'Advanced payment',
        billing: 'Billing',
        quote: 'non-binding quote',
        paypal: 'PayPal',
    },
    productionTime: 'Production time',
    deliveryTime: 'delivery time',
    productionTimeDays: '0 business days | 1 business day | {n} business days',
    defaultTermsOfPayment: 'Net 10 days',
    paymentDetails: {
        customerAndPaymentDetails: 'Customer and Payment Method',
        completeYourOrder: 'Complete Your Order',
        customer: 'Customer',
        billingAddress: 'Billing address',
        shippingAddress: 'Shipping address',
        mailing: 'Mailing',
        address: 'Address',
        inputLabels: {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            phone: 'Phone',
            company: 'Company / Department',
            referenceNumber: 'Reference Number',
            street: 'Street',
            postalCode: 'Postal Code',
            city: 'City',
            country: 'Country',
            shippingAddressDiffersFromBillingAddress:
                'differs from billing address',
            paymentMethod: 'Payment Method',
            vatRegistrationNumber: 'VAT Registration Number',
            businessOrPrivateCustomer: 'I am:',
            businessCustomer: 'Business customer',
            privateCustomer: 'Private customer',
            saveNewAddress: 'Remember Address for my next order',
            useSeperateBillingEmail: 'Send my invoice to another Email address',
            primaryEmail: 'Order confirmation and updates to',
            billingEmail: 'Send invoice also to',
        },
        paymentMethod: 'Payment Method',
    },
    finaliseOrder: {
        buyNow: 'Commit to Buy',
        goToPayPal: 'Proceed to PayPal',
        getQuote: 'Get quote',
        thankYouForOrdering: 'Thank you for your order.',
        paymentConfirmationSentTo:
            'We sent a payment confirmation to <span class="has-text-primary">{email}</span>.',
    },
    quoteGenerated: {
        headline: 'Thank you for your request.',
        emailSent: 'We sent a non-binding quote to {email}.',
    },
};
